import React from "react";
import About from "./components/About";
import Contact from "./components/Contact";
import Navbar from "./components/Navbar";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Partners from "./components/Partners";
import Copyright from "./components/Copyright";

export default function App() {
  return (
    <main className="text-stone-900 bg-sky-50 body-font">
      <Navbar />
      <About />
      <Skills />
      <Projects />
      <Partners />
      <Contact />
      <Copyright />

    </main>
  )
}



// WEBPACK FOOTER //
// ./src/App.js